"use strict";
function getMatchingIncomingsForFileName(integration, fileName) {
    return integration.incomings.filter(incoming => {
        if (!incoming.active)
            return false;
        if (incoming.incomingChannel === 'HTTP-POST') {
            return incoming.filter === fileName;
        }
        if (incoming.incomingChannel === 'FTP-file') {
            const matchRegex = new RegExp(incoming.filter);
            return matchRegex.test(fileName);
        }
        throw new Error(`Unsupported incomingChannel: ${incoming.incomingChannel}`);
    });
}
function isMissingExternalApiProperties(integration) {
    return (!integration.endpoint ||
        !integration.apiKey ||
        !integration.outgoingAuthorization);
}
module.exports = {
    isMissingExternalApiProperties,
    getMatchingIncomingsForFileName,
};
